export default __webpack_public_path__ + "static/media/productImage2.254b3655.png";